module.exports = __webpack_public_path__ + "static/media/btn_sphere_active.0dfa29b3.png";